var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ig-app",
      on: {
        touchmove: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c(
        "keep-alive",
        {
          attrs: {
            max: 5,
            include: [
              "ig-index",
              "ig-notice",
              "ig-moment",
              "ig-moment-group",
              "ig-moment-group-detail",
              "ig-moment-topic",
              "ig-moment-topic-detail",
              "ig-moment-collection",
              "ig-moment-collection-detail",
              "ig-moment-user-ranking",
              "ig-doujin",
              "ig-playbook",
              "ig-label",
              "ig-label-detail",
              "ig-video",
              "ig-me",
              "ig-user",
              "ig-home",
              "ig-favorites",
              "ig-browse",
              "ig-message",
              "ig-search"
            ]
          }
        },
        [_c("router-view")],
        1
      ),
      _c("sui-swiper-image", {
        attrs: {
          "key-name": "url",
          show: _vm.showSwiperImage,
          images: _vm.swiperImages,
          index: _vm.swiperImageIndex
        },
        on: { click: _vm.swiperImageClick }
      }),
      _c("igc-face-img", { attrs: { include: ["index", "moment"] } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }